import { zfUtils, zfcsr } from "./zf_utils";
import { zfc } from "./zfc_global";
import { zfTranslations } from "./zf_translations";
import { zfcf } from "./zfc_footer";
import { zfcsn } from "./zfc_sidenav";
import { zfcsaf } from "./zfc_search_filter";
import { zfcmwf } from "./zfc_mwf";
const rot13Cipher = require("rot13-cipher");
export class zfch2 {
    static hasTargets() {
        return $(".zfch2-header2").length > 0;
    }
    static topDropdownLangMenuInit() {
        try {
            $(".zfch2-header2-top-item-dropdown-item")
                .off("click.zfch2")
                .on("click.zfch2", function () {
                var that = $(this);
                var thatItemAnchor = that.find("button");
                if (!thatItemAnchor.hasClass("active")) {
                    that.parent().find(".active").removeClass("active");
                    thatItemAnchor.addClass("active");
                }
            });
        }
        catch (err) {
            console.log("initalization failed: zfch2.topDropdownLangMenuInit()	" + err.message);
        }
    }
    static handleFirstLevelNavItemClick(e) {
        e.preventDefault();
        if (e.originalEvent &&
            e.originalEvent.target.className.indexOf("level-1") == -1) {
            if ($(e.originalEvent.target) != undefined &&
                $(e.originalEvent.target).attr("data-link") != undefined)
                window.location.href = $(e.originalEvent.target).attr("data-link") || window.location.href;
        }
        var that = $(this).parent();
        if (zfch2.openMenu)
            zfch2.handleFirstLevelNavItemHoverOut.bind(zfch2.openMenu)();
        zfch2.handleFirstLevelNavItemHoverIn.bind(that)();
        zfch2.openMenu = that;
        return false;
    }
    static handleFirstLevelNavItemHoverIn() {
        var that = $(this);
        $(".level-1-item.active").removeClass("active");
        $(".zfch2-header2-bottom-menu-items.level-2.active")
            .css("max-height", "0px")
            .removeClass("active");
        $(".level-3-opened, .level-4-opened")
            .removeClass("level-3-opened level-4-opened")
            .find(".level-3, .level-4")
            .hide();
        var thatLevel2 = that.find(".zfch2-header2-bottom-menu-items.level-2");
        thatLevel2.scrollTop(0);
        thatLevel2.css("max-height", "none");
        if (thatLevel2.length) {
            thatLevel2.addClass("active");
            that.addClass("active");
        }
        $(".level-1-anchor").hide();
        that
            .find(".zfch2-header2-selected")
            .closest(".level-3")
            .show()
            .closest(".level-2-item")
            .addClass("level-3-opened");
        that
            .find(".zfch2-header2-selected")
            .closest(".level-4")
            .show()
            .closest(".level-3-item")
            .addClass("level-4-opened");
        zfch2.closeTopLangMenu();
        zfc.disableScroll(".zfch2-header2-bottom-menu-items");
    }
    static handleFirstLevelNavItemHoverOut() {
        zfc.enableScroll();
        var that = $(this);
        var thatLevel2 = that.find(".zfch2-header2-bottom-menu-items.level-2");
        thatLevel2.css("max-height", "0px");
        if ($(".level-3-opened").length) {
            $(".level-3-opened").each(function (index, item) {
                if ($(item).find(".zfch2-header2-selected").length == 0) {
                    $(item).removeClass("level-3-opened").find(".level-3").hide();
                }
            });
        }
        if (thatLevel2.length) {
            thatLevel2.removeClass("active");
            that.removeClass("active");
        }
        zfch2.openMenu = null;
    }
    static burgerMenuInit() {
        try {
            zfch2.burgerMenu
                .off("click.zfch2")
                .on("click.zfch2", function () {
                $(".zfch2-header-bottom-menu-ref img[data-src]").each(function (i, img) {
                    zfUtils.loadImg(img);
                });
                if (zfch2.headerWrapper.hasClass(zfch2.searchMenuOpenedClass)) {
                    zfch2.headerWrapper.removeClass(zfch2.searchMenuOpenedClass);
                    zfch2.brandWrapper.fadeIn(0);
                }
                if (zfch2.openMenu)
                    zfch2.handleFirstLevelNavItemHoverOut.bind(zfch2.openMenu)();
                zfch2.openMenu = null;
                zfch2.headerWrapper.toggleClass(zfch2.burgerOpenClass);
                if ($(".zfch2-header2-bottom-menu-content-wrapper .level-1-item").length) {
                    if (zfch2.headerWrapper.hasClass(zfch2.burgerOpenClass)) {
                        $(".zfch2-header2-bottom-menu-content-wrapper").slideDown();
                        zfch2.burgerMenu.attr("aria-expanded", "true");
                    }
                    else {
                        $(".zfch2-header2-bottom-menu-content-wrapper").slideUp();
                        zfch2.burgerMenu.attr("aria-expanded", "false");
                    }
                }
                $(".level-1-anchor").show();
                if (zfch2.headerWrapper.hasClass(zfch2.burgerOpenClass)) {
                    var currItem = $('.zfch2-header2-bottom-dropdown-menu-item-anchor[data-link*="' +
                        window.location.origin +
                        window.location.pathname +
                        '"]');
                    if (currItem.length) {
                        if (currItem.hasClass("level-1-anchor"))
                            currItem
                                .closest(".zfch2-header2-bottom-dropdown-menu-item")
                                .addClass("active");
                        else {
                            currItem
                                .find("> .level-2-anchor-text")
                                .addClass("zfch2-header2-selected");
                            currItem
                                .closest(".level-1-item")
                                .find("> .next")
                                .trigger("click");
                        }
                    }
                    if ($("body")[0].scrollHeight > $("body")[0].clientHeight)
                        $("body").addClass("zfch2-header2-hide-scroll");
                    $(".zfch2-header2-top-item-menu.active").removeClass("active");
                }
                else {
                    setTimeout(function () {
                        $("body").removeClass("zfch2-header2-hide-scroll");
                    }, 400);
                }
            });
            if (zfch2.headerWrapper.find(".zfch2-header2-bottom-dropdown-menu-item")
                .length == 0)
                zfch2.headerWrapper.addClass("zfch2-no-menu-items");
        }
        catch (err) {
            console.log("Initalization failed: zfch2.burgerMenuInit()	" + err.message);
        }
    }
    static recursiveWrap(a, column) {
        if (!a) {
            return;
        }
        var secondLevelGoal = column == 1
            ? Math.floor(a.length / (3 - column))
            : Math.ceil(a.length / (3 - column));
        if (column == 0 && a.length <= 3)
            secondLevelGoal++;
        var totalGoal = column == 1
            ? Math.floor(a.find(".level-3-item").length / (3 - column))
            : Math.ceil(a.find(".level-3-item").length / (3 - column));
        totalGoal = totalGoal + secondLevelGoal;
        if (a.length > 0) {
            var calculatingSliceCount = true;
            var sliceCount = 0;
            var secondSize = 0;
            var totalSize = 0;
            while (calculatingSliceCount) {
                sliceCount++;
                secondSize = a.slice(0, sliceCount).length;
                totalSize =
                    a.slice(0, sliceCount).find(".level-3-item").length + secondSize;
                if (sliceCount + 1 > a.length)
                    calculatingSliceCount = false;
                if (secondSize >= secondLevelGoal && totalSize > totalGoal * 0.8) {
                    calculatingSliceCount = false;
                }
            }
            var itemsToSlice = sliceCount;
            $(a.slice(0, itemsToSlice)).wrapAll('<li class="level-2-item-group"><ul class="not-default grouped-level-2-items"></ul></li>');
            a = a.slice(itemsToSlice);
            column++;
            zfch2.recursiveWrap(a, column);
        }
        else {
            return;
        }
    }
    static wrapItemGroups() {
        $(".level-1-item").each(function () {
            var that = $(this);
            var a = that.find(".level-2-item");
            var column = 0;
            zfch2.recursiveWrap(a, column);
        });
    }
    static handleInitDesktop() {
        try {
            zfch2.headerWrapper
                .find(".level-1-anchor.next")
                .off("click.zfch2")
                .on("click.zfch2", zfch2.handleFirstLevelNavItemClick);
            $(".level-2")
                .off("click.zfch2")
                .on("click.zfch2", function (e) {
                e.stopPropagation();
            });
            zfch2.wrapItemGroups();
            zfch2.brandWrapper.fadeIn(0);
            zfch2.checkDropdownHeightAndCreateAccordions();
            zfch2.headerWrapper
                .find("button[data-link]")
                .off("click.zfch2")
                .on("click.zfch2", zfch2.handleAnchorLinks);
            zfch2.headerWrapper
                .find("button[data-link]")
                .off("rightclick.zfch2")
                .on("rightclick.zfch2", zfch2.handleAnchorLinks);
        }
        catch (err) {
            console.log("Initalization failed: zfch2.handleInitDesktop()	" + err.message);
        }
    }
    static checkDropdownHeightAndCreateAccordions() {
        $(".level-1-item").each(function () {
            var that = $(this);
            var expandLevel2 = true;
            that.find(".accordion-anchor").show();
            that.find(".level-2-item-group").each(function () {
                var thatGroup = $(this);
                var groupHeight = thatGroup.find(".level-2-item, .level-3-item").length *
                    zfch2.gtelevel3MenuItemHeight +
                    thatGroup.find(".level-2-item").length *
                        zfch2.gtelevel3MenuItemHeight +
                    60;
                if (groupHeight >
                    (($(window).outerHeight() || 0) - ($(".zfch2-header2").outerHeight() || 0))) {
                    expandLevel2 = false;
                    return;
                }
            });
            that.addClass(zfch2.hasSubmenusAccordionsClass);
            expandLevel2 = true;
            that.find(".level-3-accordion-anchor").hide();
            that.find(".level-4").show();
            that.find(".level-2-accordion-anchor").hide();
            if (that.find(".zfch2-header2-selected.level-2-anchor-text").length > 0 &&
                that.find(".level-3 .zfch2-header2-selected").length > 0)
                that
                    .find(".zfch2-header2-selected.level-2-anchor-text")
                    .removeClass("zfch2-header2-selected");
            that.find(".level-3").show();
        });
    }
    static closeTopLangMenu() {
        if ($(zfch2.headerTopItemMenu).hasClass("active")) {
            $(zfch2.headerTopItemMenu).removeClass("active");
        }
    }
    static handleToggleSearchField() {
        zfch2.searchButton
            .off("click.zfch2")
            .on("click.zfch2", function (e) {
            zfch2.closeTopLangMenu();
            zfch2.headerWrapper.toggleClass(zfch2.searchMenuOpenedClass);
            if (zfch2.headerWrapper.hasClass(zfch2.searchMenuOpenedClass)) {
                e.preventDefault();
                $("#zfch2-search-input").trigger("focus");
                zfch2.searchButton.attr("aria-expanded", "true");
            }
            else {
                $(".zfch2-header2-top-item-form").trigger("submit");
            }
            if ($(zfch2.headerTopItemMenu).hasClass("active")) {
                $(zfch2.headerTopItemMenu).removeClass("active");
            }
        });
        $(".zfch2-header2-search-exit")
            .off("click.zfch2")
            .on("click.zfch2", function (e) {
            zfch2.headerWrapper.removeClass(zfch2.searchMenuOpenedClass);
            zfch2.searchButton.attr("aria-expanded", "false");
            e.preventDefault();
        });
    }
    static bindSearchInputEvents() {
        zfch2.handleToggleSearchField();
    }
    static closeSearchInput() {
        $(".zfch2-header2").removeClass(zfch2.searchMenuOpenedClass);
        zfch2.brandWrapper.fadeIn(0);
    }
    static handleAutocompleteSelected(event) {
        event = event.originalEvent.originalEvent;
        if ((event.which == 13 && !event.shiftKey || event.which == 1)) {
            zfch2.searchButton.click();
        }
    }
    static handleAnchorLinks(event) {
        event.preventDefault();
        if ($(this).find(".accordion-anchor").length &&
            $(this).find(".accordion-anchor").is(":visible")) {
            $(this).find(".accordion-anchor").trigger("click");
            return false;
        }
        var url = $(this).data("link");
        var target = $(this).data("target");
        if (target == "_blank" || event.type == "rightclick")
            window.open(url, target);
        else
            window.location = url;
        return false;
    }
    static initLanguageDropdown() {
        var _a;
        if ($('link[rel="alternate"]').length < 2)
            return;
        if ($(".zfch2-header2-top-item .langList").length)
            return;
        var curr = $('meta[name="lang"]').attr("content") || "en";
        var currUrl = $('link[rel="canonical"]').attr("href") || window.location.href;
        var items = [];
        var pageLanguages = [];
        $('link[rel="alternate"]').each(function (index, link) {
            pageLanguages.push($(link).attr("href"));
        });
        pageLanguages.forEach(function (key) {
            var _a;
            var link = $('link[href="' + key + '"][rel="alternate"]');
            var region = link.attr("region");
            var active = key == currUrl ? true : false;
            var disabled = link.length > 0 ? false : true;
            if (!disabled) {
                var item = {
                    key: key,
                    value: ((_a = zfTranslations.languages[link.attr("hreflang") || curr]) === null || _a === void 0 ? void 0 : _a[curr]) || (link.attr("hreflang") || curr),
                    active: active,
                    disabled: disabled,
                };
                items.push(item);
            }
        });
        zfUtils.createDropdown("zfch2-language-dropdown", "zfch2-language-dropdown", zfTranslations.get("languages", curr), ((_a = zfTranslations.languages[curr]) === null || _a === void 0 ? void 0 : _a[curr]) || curr, items, function (selected) {
            var link = $('link[href="' + selected + '"][rel="alternate"]');
            if (selected != currUrl) {
                localStorage.setItem("preferredLang", link.attr("hreflang") || curr || "en");
                $(".zfcsaf-button-reset").click();
                window.location.href =
                    selected + window.location.search + window.location.hash;
            }
        });
    }
    static initGlobalDropdown(data) {
        if (data.items.length == 0 &&
            data.hasOwnProperty("active") &&
            data.active != "") {
            var countryLabel = `<div class="zfcui-prometo-medium zfch2-header2-top-item zfch2-header2-top-text-item zfch2-header2-country-label">
                  <span class="zfch2-header2-top-item-link zfcui-color-inherit">` +
                data.active +
                `</span>
              </div>`;
            $(".zfch2-header2-top-items-wrapper").append(countryLabel);
            return;
        }
        if (data.items.length == 0 ||
            !data.hasOwnProperty("active") ||
            data.active == "")
            return;
        var items = [];
        data.items.forEach(function (item) {
            items.push({
                href: item.href,
                value: item.value,
                active: data.active == item.value ? true : false,
                target: item.target,
            });
        });
        if (data.link != "") {
            items.push({
                value: "",
                bold: true,
            });
            items.push({
                href: data.link,
                value: zfTranslations.get("show_locations_overview"),
                active: false,
                target: "_blank",
            });
        }
        zfUtils.createDropdown("zfch2-global-dropdown", "zfch2-global-dropdown", zfTranslations.get("all_websites"), data.active, items, function (selected) {
            window.location = selected;
        });
    }
    static menuCreateLevel(currLevel, items) {
        var menuStr = "";
        menuStr += zfUtils.handlebarsProcessTemplate(zfch2.menuListTemplate, {
            level: currLevel,
        });
        items.forEach(function (item, levelCount) {
            if (item.hasOwnProperty("children") && item.children.length == 0)
                delete item.children;
            var isExternal = (item.url.indexOf(location.host) == -1 &&
                item.url.length > 0 &&
                item.url.substr(0, 1) != "/") ||
                item.target == "_blank";
            var isHome = $(".zfch2-header2-logo > a").attr("href") == item.url ? true : false;
            if (!isHome) {
                var itemData = {
                    level: currLevel,
                    count: levelCount + 1,
                    url: item.url,
                    home: isHome,
                    external: isExternal,
                    label: item.label,
                    target: item.target,
                    hasChildren: item.hasOwnProperty("children"),
                };
                if (item.hasOwnProperty("image"))
                    itemData["image"] = item.image;
                if (item.hasOwnProperty("regions") &&
                    !(currLevel == 1 && item.hasOwnProperty("children")))
                    itemData["regions"] = item.regions.join(",");
                if (currLevel == 1 && item.hasOwnProperty("children"))
                    itemData.url = "";
                menuStr += zfUtils.handlebarsProcessTemplate(zfch2.menuItemTemplate, itemData);
                if (item.hasOwnProperty("children")) {
                    if (currLevel == 1) {
                        var newItem = {
                            url: item.url,
                            label: item.label,
                            target: item.target,
                        };
                        if (item.hasOwnProperty("image"))
                            newItem["image"] = item.image;
                        if (item.hasOwnProperty("regions"))
                            newItem["regions"] = item.regions;
                        item.children.unshift(newItem);
                    }
                    menuStr += zfch2.menuCreateLevel(currLevel + 1, item.children);
                }
                if (currLevel == 1)
                    menuStr += "</div>";
                menuStr += "</li>";
            }
        });
        menuStr += "</ul>";
        return menuStr;
    }
    static init() {
        try {
            zfch2.headerWrapper = $(".zfch2-header2");
            if (!zfch2.hasTargets())
                return;
            zfch2.burgerMenu = $(".zfch2-header2-burger-menu");
            zfch2.brandWrapper = $(".zfch2-header2-brand-wrapper");
            zfch2.searchButton = $(".zfch2-header2-search-button");
            zfch2.isTouchDevice =
                "ontouchstart" in document.documentElement ||
                    "ontouchstart" in window ||
                    navigator.maxTouchPoints > 0 ||
                    "ontouchstart" in window ||
                    (navigator.maxTouchPoints > 0 && navigator.webdriver != true) ||
                    window.navigator.maxTouchPoints > 0;
            var lenovoPattern = "(Lenovo B8080|Lenovo B6000|YOGA Tablet 2)";
            var re = new RegExp(lenovoPattern, "i");
            if (re.test(navigator.userAgent))
                zfch2.isTouchDevice = true;
            if (!zfch2.touchStartListenerAttached) {
                zfch2.touchStartListenerAttached = true;
                window.addEventListener("touchstart", function onFirstTouch() {
                    zfch2.isTouchDevice = true;
                    window.removeEventListener("touchstart", onFirstTouch, false);
                    zfch2.touchStartListenerAttached = false;
                });
            }
            zfch2.initCalled = true;
            if ($(".zfch2-page-progress-container").length == 1) {
                if (zfch2.pageProgressScrollKey !== null) {
                    zfUtils.offScroll(zfch2.pageProgressScrollKey);
                }
                zfch2.pageProgressScrollKey = zfUtils.onScroll(function () {
                    var scrolled = ((($(document.documentElement).scrollTop() || 0) /
                        ((($(document).height() || 0) - document.documentElement.clientHeight) || 1))) *
                        100;
                    $(document)
                        .find(".zfch2-page-progress-bar")
                        .css("width", scrolled + "%");
                });
            }
            var url = $(".zfch2-header-bottom-menu-ref").data("json");
            if (zfUtils.isPreview)
                url = url.replace("/templateInspection=1/", "/templateInspection=1/forceRefresh=1/");
            if (url != undefined && url != null && url.length > 0) {
                $.ajax({
                    url: url,
                    cache: true,
                })
                    .done(function (json_data) {
                    zfch2.globalSettings = json_data;
                    if (json_data.hasOwnProperty("search") &&
                        json_data.search.trim().length) {
                        if ($(".zfch2-header2-search-button").length == 0) {
                            $(".zfch2-header2-top-items-wrapper").append(`
                              <div class="zfcui-prometo-medium zfch2-header2-top-item zfch2-header2-top-input-item">
                                     <form class="zfch2-header2-top-item-form zfcui-color-inherit" action="` +
                                json_data.search.trim() +
                                `" role="search">
                                         <input name="query" type="text" class="zfch2-header2-top-item-input" placeholder="` +
                                zfTranslations.get("enter_a_search_term") +
                                `" aria-label="` +
                                zfTranslations.get("enter_a_search_term") +
                                `" role="searchbox" id="zfch2-search-input"/>
                                      <button aria-controls="zfch2-search-input,zfch2-header2-search-exit" aria-expanded="false" class="zfcui-color-inherit zfcui-icon zfcui-icon-suche zfch2-header2-top-item-link-icon zfch2-header2-search-button" type="button" role="button" aria-label="` +
                                zfTranslations.get("search") +
                                `"></button>
                                      <button id="zfch2-header2-search-exit" class="zfcui-color-inherit zfcui-icon zfcui-icon-cross-thin zfch2-header2-search-exit" role="button" aria-label="` +
                                zfTranslations.get("close_search") +
                                `"></button>
                                  </form>
                              </div>`);
                            zfcsaf.registerAutocompleteInput("zfch2-search-datalist", document.getElementById("zfch2-search-input"));
                            zfcsaf.scheduleAutocomplete(zfch2.globalSettings.hasOwnProperty("scope")
                                ? zfch2.globalSettings.scope
                                : "default", "zfch2-search-datalist", 'matchall', 15, true);
                            zfch2.searchButton = $(".zfch2-header2-search-button");
                            zfch2.bindSearchInputEvents();
                        }
                        $("#zfch2-search-input")
                            .off("keypress.zfch2search")
                            .on("keypress.zfch2search", function (e) {
                            if (e.which == 13 || e.key === "Enter") {
                                e.preventDefault();
                                zfch2.searchButton.click();
                            }
                            else {
                                var nextValue = e.currentTarget.value + (e.key || "");
                                zfcsaf.scheduleAutocomplete(zfch2.globalSettings.hasOwnProperty("scope")
                                    ? zfch2.globalSettings.scope
                                    : "default", "zfch2-search-datalist", nextValue, 15);
                            }
                        })
                            .off("focus.zfch2search click.zfch2search")
                            .on("focus.zfch2search click.zfch2search", function () {
                            var autocomplete = zfcsaf.autocompleteInstances["zfch2-search-datalist"];
                            if (autocomplete && typeof autocomplete.evaluate === "function") {
                                autocomplete.evaluate();
                                $(autocomplete.input)
                                    .off("awesomplete-selectcomplete")
                                    .on("awesomplete-selectcomplete", zfch2.handleAutocompleteSelected);
                            }
                        });
                    }
                    zfch2.initLanguageDropdown();
                    zfcsr.enabled = json_data.hasOwnProperty("use_regionalization")
                        ? json_data.use_regionalization
                        : false;
                    zfch2.menuListTemplate = zfUtils.handlebarsCompile("{{#ifCond level '==' '2'}}<div class='zfch2-level-2-wrapper'>{{/ifCond}}<ul class='zfch2-header2-bottom-menu-items not-default level-{{level}}'>{{#ifCond level '==' '1'}}<button class='zfcui-icon zfcui-icon-home' type='button'></button><li class='zfch2-categories zfcui-color-blue'>" +
                        (json_data.hasOwnProperty("menu_title")
                            ? json_data.menu_title
                            : "{{#trans 'categories'}}{{/trans}}") +
                        "</li>{{/ifCond}}");
                    zfch2.menuItemTemplate = zfUtils.handlebarsCompile(`{{#ifCond level '==' '2'}}{{#ifCond count '==' '1'}}<button class="zfcui-icon zfcui-color-cyan zfcui-icon-arrow-back zfch2-back"></button>{{/ifCond}}{{/ifCond}}<li class='zfch2-header2-bottom-dropdown-menu-item level-{{level}}-item item-{{count}} {{#if hasChildren}}{{else}}zfch2-header2-no-children{{/if}}' {{#ifCond this 'has' 'regions'}}data-region='{{regions}}'{{/ifCond}}>` +
                        (zfUtils.isWebedit ? "<a" : "<button") +
                        ` class='zfch2-header2-bottom-dropdown-menu-item-anchor level-{{level}}-anchor {{#ifCond level '==' '1'}} zfcui-aspect-5-2 {{/ifCond}}{{#if hasChildren}}next{{/if}}' {{#ifCond url '!=' ''}}` +
                        (zfUtils.isWebedit ? "href" : "data-link") +
                        `='{{url}}' data-target='{{target}}'{{/ifCond}}>
                            {{#ifCond level '==' '1'}}{{#ifCond this 'has' 'image'}}<img data-src='{{image}}' alt='{{{label}}}'>{{/ifCond}}
                                <div class='zfch2-header2-bottom-dropdown-teaser-gradient'></div>
                                <div class='zfch2-header2-bottom-dropdown-teaser-text-wrapper'>
                                    <div class='zfch2-header2-bottom-dropdown-teaser-text-title-wrapper'>
                                        <div class='zfch2-header2-bottom-dropdown-teaser-title'>{{{label}}}</div>
                                    {{#if hasChildren}}</div>
                                    {{else}}{{#if external}}<div class='zfcui-icon zfcui-icon-external-link'></div>{{/if}}</div>{{/if}}
                                </div>
                            {{/ifCond}}
                            {{#ifCond level '!=' '1'}}<span class=" level-2-anchor-text"><span class="level-2-anchor-text-label">{{#decodeHtml label}}{{/decodeHtml}}</span>{{#if external}}<span class='zfcui-icon zfcui-icon-external-link level-{{level}}-anchor-icon'></span>{{/if}}</span>{{/ifCond}}
                            {{#if hasChildren}}{{#ifCond level '!=' '1'}}<span class='zfcui-icon zfcui-icon-arrow-big-thin-d accordion-anchor level-{{level}}-accordion-anchor' role="button"></span>{{/ifCond}}{{/if}}
                        </` +
                        (zfUtils.isWebedit ? "a>" : "button>"));
                    var menuStr = zfch2.menuCreateLevel(1, json_data.navigation.items);
                    $(".zfch2-header-bottom-menu-ref").html(menuStr);
                    $(".zfch2-back")
                        .off("click.zfch2")
                        .on("click.zfch2", function () {
                        zfch2.handleFirstLevelNavItemHoverOut.bind(zfch2.openMenu)();
                        $(".level-1-anchor").show();
                    });
                    $(".zfcui-icon-home")
                        .off("click.zfch2")
                        .on("click.zfch2", function () {
                        $(".zfch2-header2-logo img").trigger("click");
                    });
                    $(".zfch2-header2-bottom-menu-content-wrapper")
                        .off("click.zfch2")
                        .on("click.zfch2", function () {
                        zfch2.burgerMenu.click();
                    });
                    zfch2.topDropdownLangMenuInit();
                    zfch2.burgerMenuInit();
                    zfch2.handleInitDesktop();
                    zfch2.initGlobalDropdown(json_data.global_dropdown);
                    if ($(".zfcbn-override").length > 0) {
                        $(".zfch2-header2 .zfcbn-breadcrumb-navigation").html($(".zfcbn-override").html());
                        $(".zfctm-text-media").first().addClass("zfcbn-override-margin");
                    }
                    if ($(".zfc-breadcrumb-enabled").length)
                        if ($(".zfch2-header2 .zfcbn-breadcrumb-navigation").is(":visible"))
                            $(".zfc-breadcrumb-enabled").css("padding-top", ($(".zfch2-header2 .zfcbn-breadcrumb-navigation").height() || 0) -
                                6 +
                                "px");
                        else
                            $(".zfc-breadcrumb-enabled").css("padding-top", "0px");
                    if (zfch2.breadcrumbResizeKey !== null) {
                        zfUtils.offResize(zfch2.breadcrumbResizeKey);
                    }
                    zfch2.breadcrumbResizeKey = zfUtils.onResize(function () {
                        if ($(".zfch2-header2 .zfcbn-breadcrumb-navigation").is(":visible"))
                            $(".zfc-breadcrumb-enabled").css("padding-top", ($(".zfch2-header2 .zfcbn-breadcrumb-navigation").height() || 0) -
                                6 +
                                "px");
                        else
                            $(".zfc-breadcrumb-enabled").css("padding-top", "0px");
                    });
                    if (json_data.hasOwnProperty("side_nav"))
                        zfcsn.init(json_data.side_nav, json_data.social_links, json_data.envelope);
                    if (json_data.hasOwnProperty("footer"))
                        zfcf.init(json_data.footer);
                    $('a[href^="znvygb:"]').each(function () {
                        $(this).attr("href", rot13Cipher($(this).attr("href")));
                        if ($(this).hasClass("mail-to"))
                            $(this).html(rot13Cipher($(this).html()));
                    });
                    zfcsr.init();
                    zfUtils.autoLangSwitch();
                    zfcsaf.init();
                    zfcmwf.showSurvey();
                    if (!zfUtils.isPreview && json_data.hasOwnProperty("piwikid"))
                        zfUtils.schedulePiwikInit(json_data.piwikid);
                    if (!zfUtils.isPreview && json_data.hasOwnProperty("onetrustid")) {
                        zfUtils.scheduleOnetrustInit(json_data.onetrustid);
                    }
                    if (!zfUtils.isPreview)
                        zfUtils.scheduleSiteimproveInit();
                    if (zfUtils.urlParams.has("clickElement")) {
                        zfc.clickElement(zfUtils.urlParams.get("clickElement"));
                    }
                })
                    .fail(function (e) {
                    console.log(e);
                });
            }
        }
        catch (err) {
            console.log("Initalization failed: zfch2.init()	" + err.message);
        }
    }
}
zfch2.lastMovedOutItem = null;
zfch2.headerTopItemMenu = ".zfch2-header2-top-item-menu";
zfch2.globalSettings = {};
zfch2.initCalled = false;
zfch2.isTouchDevice = false;
zfch2.gtelevel3MenuItemHeight = 35;
zfch2.burgerOpenClass = "burger-menu-opened";
zfch2.searchMenuOpenedClass = "search-menu-opened";
zfch2.hasSubmenusAccordionsClass = "has-submenus-accordions";
zfch2.pageProgressScrollKey = null;
zfch2.breadcrumbResizeKey = null;
zfch2.touchStartListenerAttached = false;
try {
    zfUtils.onReady(zfch2.init);
}
catch (err) {
    console.log("Initalization failed: zfch2.init()	" + err.message);
}
